module.exports = "<div class=\"accordion_group\" [class.open]=\"open\" [class.hidden]=\"hidden\"\n     [attr.id]=\"id ? id : null\">\n    <div class=\"group_name\" (click)=\"toggleSlide()\">\n        <h2>\n            <span [innerHTML]=\"title | translate | highlight:highlightPhrase:3\"></span>\n            <span *ngIf=\"numFound > 0\">({{ numFound }})</span>\n        </h2>\n        <i class=\"material-icons\">{{ open ? '&#xE313;' : '&#xE316;' }}</i>\n    </div>\n    <div class=\"group_content\">\n        <ng-content></ng-content>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/ui-elements/ui-accordion-group/ui-accordion-group.html
// module id = 1190
// module chunks = 1